/**
 * Registers the thumbnail-caching Service Worker.
 *
 * The worker (`/thumbnail-sw.js`, served from `public/`) intercepts requests
 * for photo thumbnails on Azure Blob Storage / Azurite and serves them
 * cache-first. See `public/thumbnail-sw.js` for details.
 *
 * Registration is best-effort: any failure is logged and swallowed so a
 * broken SW never blocks the app from loading.
 */

const SW_URL = '/thumbnail-sw.js';
const THUMBNAIL_CACHE_PREFIX = 'thumbnails-';

export function registerThumbnailServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Defer until the page has loaded so SW registration doesn't compete with
  // the initial render.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL, { scope: '/' })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[thumbnail-sw] registration failed:', err);
      });
  });
}

export async function clearThumbnailServiceWorkerCache(): Promise<void> {
  if (typeof window === 'undefined') return;
  if (typeof caches === 'undefined') return;

  try {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith(THUMBNAIL_CACHE_PREFIX))
        .map((name) => caches.delete(name))
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[thumbnail-sw] cache clear failed:', err);
  }
}
